import { put, takeEvery } from 'redux-saga/effects';
import { resetPassword } from 'api/signIn';
import { startResetPasswordSubmit, resolveResetPasswordSubmit } from './actions';

export function* resetPasswordSubmitSaga(action: any) {
  try {
    yield resetPassword(action.payload);
    yield put(resolveResetPasswordSubmit());
  } catch (error) {
    yield put(resolveResetPasswordSubmit(error.response));
  }
}

export default function* resetPasswordSaga() {
  yield takeEvery(startResetPasswordSubmit, resetPasswordSubmitSaga);
}
